import React from "react";
import DashboardNavbar from "../components/DashboardNavbar.js";
import Sidebar from "../components/Sidebar.js";
import DashboardFooter from "../components/DashboardFooter.js";
import {
    Flex,
} from "@chakra-ui/react";
import { CreateChallengeForm } from "../components/CreateChallengeForm";

const CreateChallenge = () => {

    return (
        <>
            <Sidebar />
            <div className="relative md:ml-64 bg-white">
                <DashboardNavbar title="Create Challenge" hideBecomeAMentorButton={true} />
                {/* Header */}
                <div className="relative bg-white md:pt-32 pb-16"></div>
                <div className="px-4 md:px-10 mx-auto w-full -m-24">
                    <div className="flex flex-wrap mt-4">
                        <div className="w-full  mb-12 xl:mb-0 px-2">
                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded">
                                <div className="rounded-t mb-0 px-2 border-0">
                                    <Flex w={["100%", "100%", "100%", "70%"]} justifyContent="center">
                                        {/* <CreateChallengeFormSkeleton /> */}
                                        <CreateChallengeForm />
                                    </Flex>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DashboardFooter title="Create Challenge" />
                </div>
            </div>
        </>
    )
}

export default CreateChallenge;
